import type { ProgramBenefitsPageProps } from './ProgramBenefitsPage.component';

// Default toggles shown for every program. Strings MUST match
// `core/backend/seeds/reference-tables/benefits.json` exactly so the BFF
// resolves them to seeded `benefit.id` rows on save (instead of the
// `custom_name` fallback). Custom benefits the recruiter types via the
// "Adicionar" dialog still persist per-program through the custom_name path.
export const BENEFIT_OPTIONS = [
  'Assistência Médica',
  'Assistência Odontológica',
  'Auxílio Academia',
  'Auxílio Creche',
  'Auxílio Home Office',
  'Cesta Básica',
  'Day Off Aniversário',
  'Incentivo à Educação',
  'Seguro de Vida',
  'Vale Alimentação',
  'Vale Transporte',
] as const;

// Same naming contract as BENEFIT_OPTIONS — see
// `core/backend/seeds/reference-tables/additional_payment.json`. The seed
// is small (4 entries); anything else the recruiter types is stored as
// custom_name on this program.
export const ADDITIONAL_PAYMENT_OPTIONS = [
  'Adc. insalubridade',
  'Adc. periculosidade',
  'Bônus',
  'Comissão',
] as const;

export const defaultProps: ProgramBenefitsPageProps = {
  benefitOptions: BENEFIT_OPTIONS,
  selectedBenefits: [],
  onToggleBenefit: () => undefined,
  onAddBenefit: () => undefined,
  additionalPaymentOptions: ADDITIONAL_PAYMENT_OPTIONS,
  selectedAdditionalPayments: [],
  onToggleAdditionalPayment: () => undefined,
  onAddAdditionalPayment: () => undefined,
  progress: 60,
  onBack: () => undefined,
  onSubmit: () => undefined,
  isSubmitting: false,
};

export const filledProps: ProgramBenefitsPageProps = {
  ...defaultProps,
  selectedBenefits: ['Assistência médica', 'Vale-alimentação (VA)', 'Auxílio home office'],
  selectedAdditionalPayments: ['Décimo terceiro', 'PLR', 'Bônus por resultado'],
};
